import { PublicOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Result from 'components/v2/common/Result';
import * as S from '../ClientProfile.styled';
import { RelativeAbroad } from '../ClientProfile';

import useEnabledCountries from 'hooks/useEnabledCountries';
import { RootState } from 'redux/store';

type Props = {
    relativesAbroadData: null | RelativeAbroad[];
    mobile: boolean;
};

const RelativesAbroad = ({ relativesAbroadData, mobile }: Props) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const { hasSelfServeMarket, has } = useEnabledCountries();
    return (
        <>
            {relativesAbroadData && relativesAbroadData.length > 0 ? (
                <>
                    {relativesAbroadData.map((relative: RelativeAbroad, index: number) => (
                        <div key={index}>
                            {relativesAbroadData.length > 1 && (
                                <S.Title>{`Relative ${index + 1}`}</S.Title>
                            )}
                            <S.InfoItem>
                                <Tooltip title={t('relation', { lng: language })}>
                                    <S.Label>{t('relation', { lng: language })}</S.Label>
                                </Tooltip>
                                <Tooltip title={relative.relation}>
                                    <S.Info mobile={mobile}>{relative.relation}</S.Info>
                                </Tooltip>
                            </S.InfoItem>
                            <S.InfoItem>
                                <Tooltip title={t('country', { lng: language })}>
                                    <S.Label>{t('country', { lng: language })}</S.Label>
                                </Tooltip>
                                <Tooltip title={relative.country}>
                                    <S.Info mobile={mobile}>{relative.country}</S.Info>
                                </Tooltip>
                            </S.InfoItem>
                            {/* UK + AU — same as AssessmentV2/RelativesAbroadForm. */}
                            {hasSelfServeMarket && (
                                <S.InfoItem>
                                    <Tooltip title={t('countryOfBirth', { lng: language })}>
                                        <S.Label mobile={mobile}>
                                            {t('countryOfBirth', { lng: language })}
                                        </S.Label>
                                    </Tooltip>
                                    <Tooltip title={relative.country_of_birth}>
                                        <S.Info mobile={mobile}>{relative.country_of_birth}</S.Info>
                                    </Tooltip>
                                </S.InfoItem>
                            )}
                            {/* UK-only fields — same as AssessmentV2/RelativesAbroadForm. */}
                            {has('UK') && (
                                <>
                                    <S.InfoItem>
                                        <Tooltip title={t('maritalStatus', { lng: language })}>
                                            <S.Label mobile={mobile}>
                                                {t('maritalStatus', { lng: language })}
                                            </S.Label>
                                        </Tooltip>
                                        <Tooltip title={relative.marital_status}>
                                            <S.Info mobile={mobile}>
                                                {relative.marital_status}
                                            </S.Info>
                                        </Tooltip>
                                    </S.InfoItem>
                                    <S.InfoItem>
                                        <Tooltip title={t('nationality', { lng: language })}>
                                            <S.Label mobile={mobile}>
                                                {t('nationality', { lng: language })}
                                            </S.Label>
                                        </Tooltip>
                                        <Tooltip title={relative.nationality}>
                                            <S.Info mobile={mobile}>{relative.nationality}</S.Info>
                                        </Tooltip>
                                    </S.InfoItem>
                                </>
                            )}
                            <S.InfoItem>
                                <Tooltip title={t('region', { lng: language })}>
                                    <S.Label>{t('region', { lng: language })}</S.Label>
                                </Tooltip>
                                <Tooltip title={relative.region}>
                                    <S.Info mobile={mobile}>{relative.region}</S.Info>
                                </Tooltip>
                            </S.InfoItem>
                            <S.InfoItem>
                                <Tooltip title={t('residenceStatus', { lng: language })}>
                                    <S.Label mobile={mobile}>
                                        {t('residenceStatus', { lng: language })}
                                    </S.Label>
                                </Tooltip>
                                <Tooltip title={relative.residency_status}>
                                    <S.Info mobile={mobile}>{relative.residency_status}</S.Info>
                                </Tooltip>
                            </S.InfoItem>
                            <S.InfoItem>
                                <Tooltip title={t('residenceStatusSince', { lng: language })}>
                                    <S.Label mobile={mobile}>
                                        {t('residenceStatusSince', { lng: language })}
                                    </S.Label>
                                </Tooltip>
                                <Tooltip title={relative.residence_since}>
                                    <S.Info mobile={mobile}>{relative.residence_since}</S.Info>
                                </Tooltip>
                            </S.InfoItem>

                            <S.InfoItem>
                                <Tooltip title={t('age', { lng: language })}>
                                    <S.Label>{t('age', { lng: language })}</S.Label>
                                </Tooltip>
                                <Tooltip title={relative.age}>
                                    <S.Info mobile={mobile}>{relative.age}</S.Info>
                                </Tooltip>
                            </S.InfoItem>
                        </div>
                    ))}
                </>
            ) : (
                <Result
                    icon={<PublicOutlined sx={{ fontSize: 32 }} />}
                    title={t('noInfo', { lng: language })}
                    description="No relatives abroad have been added yet."
                />
            )}
        </>
    );
};

export default RelativesAbroad;
